import type { FC, MouseEventHandler } from "react";
import { IconMinus } from "@web-monorepo/dds-icons";
import styles from "./XButton.module.css";
import { clsx } from "clsx";

type Props = {
  className?: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
};

const XButton: FC<Props> = ({ className, onClick }) => (
  <button aria-label="cancel" className={clsx(styles.xButton, className)} onClick={onClick}>
    <IconMinus size="s" color={"dt_content_primary"} />
  </button>
);

export default XButton;
